import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { label: "THE PROBLEM", href: "#the-problem" },
  { label: "THE SYSTEM", href: "#the-system" },
  { label: "PROOF", href: "#proof" },
  { label: "PRICING", href: "#pricing" },
];

export default function Nav() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 600);
    return () => clearTimeout(t);
  }, []);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.nav
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="fixed left-0 right-0 top-6 z-[100] mx-auto flex justify-center pointer-events-none"
          data-testid="wam-nav"
        >
          <div
            className="flex items-center gap-1 md:gap-2 rounded-full px-2 py-2 md:px-3 md:py-2 pointer-events-auto"
            style={{
              background: "rgba(7,7,9,0.85)",
              border: "1px solid rgba(240,236,228,0.08)",
              backdropFilter: "blur(16px)",
              WebkitBackdropFilter: "blur(16px)",
            }}
          >
            <a
              href="#top"
              onClick={scrollTo("#top")}
              data-testid="nav-wordmark"
              className="px-3 md:px-4 py-2 font-mono text-[11px] tracking-[0.32em] text-[#C9A84C]"
            >
              WAM
            </a>
            <div className="hidden md:flex items-center gap-1">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={scrollTo(l.href)}
                  data-testid={`nav-link-${l.href.replace("#", "")}`}
                  className="px-3 py-2 font-mono text-[10px] tracking-[0.22em] text-[#F0ECE4]/70 hover:text-[#F0ECE4] transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </div>
            <button
              onClick={scrollTo("#apply")}
              data-testid="nav-apply-btn"
              className="ml-1 md:ml-2 rounded-full bg-[#C9A84C] px-4 md:px-5 py-2 font-body text-[10px] md:text-[11px] font-bold uppercase tracking-[0.14em] text-[#070709] transition-transform hover:-translate-y-[1px]"
            >
              Apply Now →
            </button>
          </div>
        </motion.nav>
      )}
    </AnimatePresence>
  );
}
